// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.a5C6tq1UULIl7TigYgvd>div{width:10px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/billing/pages/overview/ui/PaymentMethods/store/styles.module.scss"],"names":[],"mappings":"AACE,0BACE,UAAA","sourcesContent":[".setPrimaryTooltip {\n  > div {\n    width: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"setPrimaryTooltip": `a5C6tq1UULIl7TigYgvd`
};
export default ___CSS_LOADER_EXPORT___;
